<template>
  <div class="gene-panel">
    <back-button />
    <h3 class="title">Gene Panel</h3>
    <div class="flex-item_center">
      Panel of 32 genes sufficient to deliver complete classification and risk
      stratification.
      <sui-table collapsing compact="very">
        <sui-table-header>
          <sui-table-row>
            <sui-table-header-cell>Class Defining Genes</sui-table-header-cell>
            <sui-table-header-cell>Independent Genes</sui-table-header-cell>
          </sui-table-row>
        </sui-table-header>
        <sui-table-body>
          <sui-table-row v-for="rowIndex in numRows" :key="rowIndex">
            <sui-table-cell>{{
              classDefiningGenes[rowIndex - 1]
            }}</sui-table-cell>
            <sui-table-cell>{{
              independentGenes[rowIndex - 1] || ""
            }}</sui-table-cell>
          </sui-table-row>
        </sui-table-body>
        <sui-table-footer>
          <sui-table-header-cell
            >Total, N={{ classDefiningGenes.length }}</sui-table-header-cell
          >
          <sui-table-header-cell
            >Total, N={{ independentGenes.length }}</sui-table-header-cell
          >
        </sui-table-footer>
      </sui-table>
    </div>
  </div>
</template>

<script>
import BackButton from "@/components/BackButton";

const classDefiningGenes = [
  "NPM1",
  "TP53",
  "WT1",
  "CEBPA",
  "DNMT3A",
  "IDH1",
  "IDH2",
  "ZRSR2",
  "U2AF1",
  "SRSF2",
  "SF3B1",
  "ASXL1",
  "STAG2",
  "BCOR",
  "RUNX1",
  "EZH2",
  "MLL",
  "PHF6",
  "SF1",
  "NF1",
  "CUX1",
  "SETBP1",
  "FLT3 ",
  "TET2"
];

const independentGenes = [
  "KIT",
  "KRAS",
  "NRAS",
  "PTPN11",
  "GATA2",
  "MYC",
  "MPL",
  "SMC3"
];

export default {
  name: "GenePanel",
  components: {
    BackButton
  },
  data() {
    return {
      classDefiningGenes,
      independentGenes
    };
  },
  mounted() {
    window.analytics.page("GenePanel");
  },
  computed: {
    numRows() {
      return Math.max(classDefiningGenes.length, independentGenes.length);
    }
  }
};
</script>

<style lang="scss">
.gene-panel {
  text-align: center;
  h3.title {
    color: #00113d;
    text-align: center;
    margin-top: 0;
  }
  .ui.table.collapsing {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-top: 20px;
    tr th {
      min-width: 200px;
      color: #00113d;
    }
    tfoot th {
      color: #00113d;
      font-weight: 600;
    }
  }
}
</style>
